/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type AccountSettings_user = {|
  +serviceId: ?string;
  +facebookUserSocialNetwork: ?$ReadOnlyArray<?{| |}>;
  +pinterestUserSocialNetwork: ?$ReadOnlyArray<?{| |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountSettings_user",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "serviceId",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": "facebookUserSocialNetwork",
      "args": [
        {
          "kind": "Literal",
          "name": "socialNetworkNames",
          "value": [
            "FACEBOOK"
          ],
          "type": "[SocialNetworkNames]"
        }
      ],
      "concreteType": null,
      "name": "socialNetworks",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "FacebookAccountSettings_userSocialNetwork",
          "args": null
        }
      ],
      "storageKey": "socialNetworks{\"socialNetworkNames\":[\"FACEBOOK\"]}"
    },
    {
      "kind": "LinkedField",
      "alias": "pinterestUserSocialNetwork",
      "args": [
        {
          "kind": "Literal",
          "name": "socialNetworkNames",
          "value": [
            "PINTEREST"
          ],
          "type": "[SocialNetworkNames]"
        }
      ],
      "concreteType": null,
      "name": "socialNetworks",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PinterestAccountSettings_userSocialNetwork",
          "args": null
        }
      ],
      "storageKey": "socialNetworks{\"socialNetworkNames\":[\"PINTEREST\"]}"
    }
  ],
  "type": "User"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./assets/js/global/components/SocialNetworks/__generated__/AccountSettings_user.graphql.js